import { FC, memo } from "react";
import { ChatFrameContainer } from "./components/chat-frame-container";
import { ChatFrameHeader } from "./components/chat-frame-header";
import { ChatFrameBody } from "./components/chat-frame-body";
import { ChatFrameFooter } from "./components/chat-frame-footer";
import { useAppSelector } from "../../../common/store";
import { ChatFrameActionsContainer } from "./components/chat-frame-actions-container";
import { ChatFrameCallContainer } from "./components/chat-frame-call-container";

interface ChatFrameProps {
  frameHeaderComponent: JSX.Element;
  frameBodyComponent: JSX.Element;
  frameFooterComponent: JSX.Element;
  frameActionsComponent: JSX.Element;
}

const ChatFrame: FC<ChatFrameProps> = ({
  frameHeaderComponent,
  frameBodyComponent,
  frameFooterComponent,
  frameActionsComponent,
}) => {
  const isOpen = useAppSelector(state => state["app-state"].isOpen);

  return (
    <ChatFrameContainer isOpen={isOpen} className={`voa_chat_container ${isOpen ? 'maximize' : 'minimize'}`}>
      <ChatFrameHeader>
        {frameHeaderComponent}
      </ChatFrameHeader>
      <ChatFrameBody>
        {frameBodyComponent}
      </ChatFrameBody>
      <ChatFrameFooter>
        {frameFooterComponent}
      </ChatFrameFooter>
      <ChatFrameActionsContainer>
        {frameActionsComponent}
      </ChatFrameActionsContainer>
    </ChatFrameContainer>
  )
};

export default ChatFrame;
